
export const dataconfig = {
  undoRedo: false, //Undo redo
  paintFormat: false, //Format brush
  currencyFormat: false, //currency format
  percentageFormat: false, //Percentage format
  numberDecrease: false, //'Decrease the number of decimal places'
  numberIncrease: false, //'Increase the number of decimal places
  moreFormats: false, //'More Formats'
  font: false, //'font'
  fontSize: false, //'Font size'
  bold: false, //'Bold (Ctrl+B)'
  italic: false, //'Italic (Ctrl+I)'
  strikethrough: false, //'Strikethrough (Alt+Shift+5)'
  underline: false, // 'Underline (Alt+Shift+6)'
  textColor: false, //'Text color'
  fillColor: true, //'Cell color'
  border: false, //'border'
  mergeCell: false, //'Merge cells' 
  horizontalAlignMode: false, //'Horizontal alignment'
  verticalAlignMode: false, //'Vertical alignment'
  textWrapMode: false, //'Wrap mode'
  textRotateMode: false, //'Text Rotation Mode'
  image: false, // 'Insert picture'
  link: false, // 'Insert link'
  chart: false, //'chart' (the icon is hidden, but if the chart plugin is configured, you can still create a new chart by right click)
  postil: true, //'comment'
  pivotTable: false, //'PivotTable'
  function: false, //'formula'
  frozenMode: true, //'freeze mode'
  sortAndFilter: true, //'Sort and filter'
  conditionalFormat: false, //'Conditional Format'
  dataVerification: false, // 'Data Verification'
  splitColumn: false, //'Split column'
  screenshot: false, //'screenshot'
  findAndReplace: true, //'Find and Replace'
  protection: false, // 'Worksheet protection'
  print: false, // 'Print'
  clearFormat: true,
  filterCustom: true,
}

export const dataconfigDatacontHistory = {
  undoRedo: false, //Undo redo
  paintFormat: false, //Format brush
  currencyFormat: false, //currency format
  percentageFormat: false, //Percentage format
  numberDecrease: false, //'Decrease the number of decimal places'
  numberIncrease: false, //'Increase the number of decimal places
  moreFormats: false, //'More Formats'
  font: false, //'font'
  fontSize: false, //'Font size'
  bold: false, //'Bold (Ctrl+B)'
  italic: false, //'Italic (Ctrl+I)'
  strikethrough: false, //'Strikethrough (Alt+Shift+5)'
  underline: false, // 'Underline (Alt+Shift+6)'
  textColor: false, //'Text color'
  fillColor: true, //'Cell color'
  border: false, //'border'
  mergeCell: false, //'Merge cells' 
  horizontalAlignMode: false, //'Horizontal alignment'
  verticalAlignMode: false, //'Vertical alignment'
  textWrapMode: false, //'Wrap mode'
  textRotateMode: false, //'Text Rotation Mode'
  image: false, // 'Insert picture'
  link: false, // 'Insert link'
  chart: false, //'chart' (the icon is hidden, but if the chart plugin is configured, you can still create a new chart by right click)
  postil: true, //'comment'
  pivotTable: false, //'PivotTable'
  function: false, //'formula'
  frozenMode: true, //'freeze mode'
  sortAndFilter: true, //'Sort and filter'
  conditionalFormat: false, //'Conditional Format'
  dataVerification: false, // 'Data Verification'
  splitColumn: false, //'Split column'
  screenshot: false, //'screenshot'
  findAndReplace: true, //'Find and Replace'
  protection: false, // 'Worksheet protection'
  print: false, // 'Print'
  clearFormat: true,
  filterCustom: false,
}

export const dataconfiFclHistory = {
  undoRedo: false, //Undo redo
  paintFormat: false, //Format brush
  currencyFormat: false, //currency format
  percentageFormat: false, //Percentage format
  numberDecrease: false, //'Decrease the number of decimal places'
  numberIncrease: false, //'Increase the number of decimal places
  moreFormats: false, //'More Formats'
  font: false, //'font'
  fontSize: false, //'Font size'
  bold: false, //'Bold (Ctrl+B)'
  italic: false, //'Italic (Ctrl+I)'
  strikethrough: false, //'Strikethrough (Alt+Shift+5)'
  underline: false, // 'Underline (Alt+Shift+6)'
  textColor: false, //'Text color'
  fillColor: false, //'Cell color'
  border: false, //'border'
  mergeCell: false, //'Merge cells' 
  horizontalAlignMode: false, //'Horizontal alignment'
  verticalAlignMode: false, //'Vertical alignment'
  textWrapMode: false, //'Wrap mode'
  textRotateMode: false, //'Text Rotation Mode'
  image: false, // 'Insert picture'
  link: false, // 'Insert link'
  chart: false, //'chart' (the icon is hidden, but if the chart plugin is configured, you can still create a new chart by right click)
  postil: false, //'comment'
  pivotTable: false, //'PivotTable'
  function: false, //'formula'
  frozenMode: false, //'freeze mode'
  sortAndFilter: true, //'Sort and filter'
  conditionalFormat: false, //'Conditional Format'
  dataVerification: false, // 'Data Verification'
  splitColumn: false, //'Split column'
  screenshot: false, //'screenshot'
  findAndReplace: true, //'Find and Replace'
  protection: false, // 'Worksheet protection'
  print: false, // 'Print'
  exportXlsx: false,
  clearFormat: true,
  filterCustom: false,
}

export const dataconfigfclpage = {
  undoRedo: false, //Undo redo
  paintFormat: false, //Format brush
  currencyFormat: false, //currency format
  percentageFormat: false, //Percentage format
  numberDecrease: false, //'Decrease the number of decimal places'
  numberIncrease: false, //'Increase the number of decimal places
  moreFormats: false, //'More Formats'
  font: false, //'font'
  fontSize: false, //'Font size'
  bold: false, //'Bold (Ctrl+B)'
  italic: false, //'Italic (Ctrl+I)'
  strikethrough: false, //'Strikethrough (Alt+Shift+5)'
  underline: false, // 'Underline (Alt+Shift+6)'
  textColor: false, //'Text color'
  fillColor: true, //'Cell color'
  border: false, //'border'
  mergeCell: false, //'Merge cells' 
  horizontalAlignMode: false, //'Horizontal alignment'
  verticalAlignMode: false, //'Vertical alignment'
  textWrapMode: false, //'Wrap mode'
  textRotateMode: false, //'Text Rotation Mode'
  image: false, // 'Insert picture'
  link: false, // 'Insert link'
  chart: false, //'chart' (the icon is hidden, but if the chart plugin is configured, you can still create a new chart by right click)
  postil: true, //'comment'
  pivotTable: false, //'PivotTable'
  function: false, //'formula'
  frozenMode: true, //'freeze mode'
  sortAndFilter: false, //'Sort and filter'
  conditionalFormat: false, //'Conditional Format'
  dataVerification: false, // 'Data Verification'
  splitColumn: false, //'Split column'
  screenshot: false, //'screenshot'
  findAndReplace: true, //'Find and Replace'
  protection: false, // 'Worksheet protection'
  print: false, // 'Print'
  clearFormat: true,
  filterCustom: true,
}


export const dataconfighistory = {
  undoRedo: false, //Undo redo
  paintFormat: false, //Format brush
  currencyFormat: false, //currency format
  percentageFormat: false, //Percentage format
  numberDecrease: false, //'Decrease the number of decimal places'
  numberIncrease: false, //'Increase the number of decimal places
  moreFormats: false, //'More Formats'
  font: false, //'font'
  fontSize: false, //'Font size'
  bold: false, //'Bold (Ctrl+B)'
  italic: false, //'Italic (Ctrl+I)'
  strikethrough: false, //'Strikethrough (Alt+Shift+5)'
  underline: false, // 'Underline (Alt+Shift+6)'
  textColor: false, //'Text color'
  fillColor: false, //'Cell color'
  border: false, //'border'
  mergeCell: false, //'Merge cells' 
  horizontalAlignMode: false, //'Horizontal alignment'
  verticalAlignMode: false, //'Vertical alignment'
  textWrapMode: false, //'Wrap mode'
  textRotateMode: false, //'Text Rotation Mode'
  image: false, // 'Insert picture'
  link: false, // 'Insert link'
  chart: false, //'chart' (the icon is hidden, but if the chart plugin is configured, you can still create a new chart by right click)
  postil: false, //'comment'
  pivotTable: false, //'PivotTable'
  function: false, //'formula'
  frozenMode: false, //'freeze mode'
  sortAndFilter: true, //'Sort and filter'
  conditionalFormat: false, //'Conditional Format'
  dataVerification: false, // 'Data Verification'
  splitColumn: false, //'Split column'
  screenshot: false, //'screenshot'
  findAndReplace: true, //'Find and Replace'
  protection: false, // 'Worksheet protection'
  print: false, // 'Print'
  exportXlsx: false,
}

export const dataconfigReportDataCont = {
  undoRedo: false, //Undo redo
  paintFormat: false, //Format brush
  currencyFormat: false, //currency format
  percentageFormat: false, //Percentage format
  numberDecrease: false, //'Decrease the number of decimal places'
  numberIncrease: false, //'Increase the number of decimal places
  moreFormats: false, //'More Formats'
  font: false, //'font'
  fontSize: false, //'Font size'
  bold: false, //'Bold (Ctrl+B)'
  italic: false, //'Italic (Ctrl+I)'
  strikethrough: false, //'Strikethrough (Alt+Shift+5)'
  underline: false, // 'Underline (Alt+Shift+6)'
  textColor: false, //'Text color'
  fillColor: false, //'Cell color'
  border: false, //'border'
  mergeCell: false, //'Merge cells' 
  horizontalAlignMode: false, //'Horizontal alignment'
  verticalAlignMode: false, //'Vertical alignment'
  textWrapMode: false, //'Wrap mode'
  textRotateMode: false, //'Text Rotation Mode'
  image: false, // 'Insert picture'
  link: false, // 'Insert link'
  chart: false, //'chart' (the icon is hidden, but if the chart plugin is configured, you can still create a new chart by right click)
  postil: false, //'comment'
  pivotTable: false, //'PivotTable'
  function: false, //'formula'
  frozenMode: true, //'freeze mode'
  sortAndFilter: true, //'Sort and filter'
  conditionalFormat: false, //'Conditional Format'
  dataVerification: false, // 'Data Verification'
  splitColumn: false, //'Split column'
  screenshot: true, //'screenshot'
  findAndReplace: true, //'Find and Replace'
  protection: false, // 'Worksheet protection'
  print: false, // 'Print'
  exportXlsx: false,
  clearFormat: false,
  filterCustom: false,
}
export const showtoolbarConfig = {
  tracking:true,
  copy: true, // copy
  copyAs: false, // copy as
  paste: true, // paste
  insertRow: false, // insert row
  insertColumn: false, // insert column
  deleteRow: false, // delete the selected row
  deleteColumn: false, // delete the selected column
  deleteCell: false, // delete cell
  hideRow: false, // hide the selected row and display the selected row
  hideColumn: false, // hide the selected column and display the selected column
  rowHeight: true, // row height
  columnWidth: true, // column width
  clear: false, // clear content
  matrix: false, // matrix operation selection
  sort: false, // sort selection,
  filter: false, // filter selection
  chart: false, // chart generation
  image: false, // insert picture
  link: false, // insert link
  data: false, // data verification
  cellFormat: false // Set cell format
}
